/**
 * @generated SignedSource<<dd5c1c1cdbfdaf380bcf36b39ea127ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Page_embedSlugS_productizedService$data = {
  readonly title: string;
  readonly userProfile: {
    readonly firstName: string | null;
    readonly lastName: string | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EmbeddedBuyNowLayout_productizedService">;
  readonly " $fragmentType": "Page_embedSlugS_productizedService";
};
export type Page_embedSlugS_productizedService$key = {
  readonly " $data"?: Page_embedSlugS_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"Page_embedSlugS_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Page_embedSlugS_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EmbeddedBuyNowLayout_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "6efe39452a485e8889b5d689db4cd7d5";

export default node;
